import { useEffect, useState } from "react";
import {
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Typography,
} from "@mui/material";
import { usePepStore } from "../../store/pep.store";
import { useAuthStore } from "../../store/auth.store";

/**
 * Глобальная модалка «Соглашение об использовании ПЭП» (ТЗ 8.4).
 * Всплывает при первом входе, когда бэк сообщает accepted=false (он же сверяет версию).
 * «Не согласен» — можно закрыть, но функции подписания/голосования остаются заблокированы
 * (флаг хранится в pep-сторе и проверяется на страницах собраний).
 */
export function PepAgreementModal() {
    const accessToken = useAuthStore((s) => s.accessToken);
    const { agreement, loadAgreement, accept } = usePepStore();
    const [open, setOpen] = useState(false);
    const [dismissed, setDismissed] = useState(false);
    const [submitting, setSubmitting] = useState(false);

    // загрузить соглашение при входе (когда есть токен)
    useEffect(() => {
        if (accessToken) {
            loadAgreement();
        }
    }, [accessToken, loadAgreement]);

    // показать, если соглашение загружено и не принято (и юзер не закрыл вручную)
    useEffect(() => {
        if (agreement && !agreement.accepted && !dismissed) {
            setOpen(true);
        } else {
            setOpen(false);
        }
    }, [agreement, dismissed]);

    const handleAccept = async () => {
        setSubmitting(true);
        const ok = await accept();
        setSubmitting(false);
        if (ok) setOpen(false);
    };

    const handleDecline = () => {
        // закрыть, но согласие не зафиксировано — подписание/голосование останутся заблокированы
        setDismissed(true);
        setOpen(false);
    };

    if (!agreement) return null;

    return (
        <Dialog
            open={open}
            onClose={() => {}}
            disableEscapeKeyDown
            fullWidth
            maxWidth="md"
            scroll="paper"
        >
            <DialogTitle>
                Соглашение об использовании простой электронной подписи
                <Typography variant="caption" sx={{ display: "block", color: "text.secondary" }}>
                    Версия {agreement.version}
                </Typography>
            </DialogTitle>
            <DialogContent dividers>
                <Typography sx={{ whiteSpace: "pre-wrap", lineHeight: 1.6 }}>
                    {agreement.text}
                </Typography>
            </DialogContent>
            <DialogActions sx={{ px: 3, py: 2 }}>
                <Box sx={{ flexGrow: 1 }}>
                    <Typography variant="caption" color="text.secondary">
                        Без принятия Соглашения голосование недоступно.
                    </Typography>
                </Box>
                <Button onClick={handleDecline} disabled={submitting} color="inherit">
                    Не согласен
                </Button>
                <Button onClick={handleAccept} disabled={submitting} variant="contained">
                    Принять
                </Button>
            </DialogActions>
        </Dialog>
    );
}
